<template>
    <h2 class="profile-headline" :title="headline">{{ headline }}</h2>
</template>

<script setup lang="ts">
    defineProps<{
        headline: string;
    }>();
</script>

<style scoped lang="scss">
    .profile-headline {
        margin: 0;
        overflow-wrap: break-word;
        font-weight: var(--joy-font-weight-bold);
        font-size: var(--joy-font-size-primary-400);
        line-height: var(--joy-line-height-large);
        text-align: left;
        text-transform: capitalize;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        line-clamp: 3;
        -webkit-line-clamp: 3;
    }
</style>
